import { render, staticRenderFns } from "./CreateQuestionnaire.vue?vue&type=template&id=02350a2b"
import script from "./CreateQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./CreateQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports